import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enSentara from './common/locales/en/sentara.json';
import enAvMed from './common/locales/en/avmed.json';
import esSentara from './common/locales/es/sentara.json';
import esAvMed from './common/locales/es/avmed.json';
import merge from 'deepmerge';
import { isAvMed } from './context';

interface Translation {
  [key: string]: string | string[] | Translation;
}

export enum Brand {
  SENTARA = 'sentara',
  AVMED = 'avMed',
}

const enSentaraTyped: Translation = enSentara;
const enAvMedTyped: Translation = enAvMed;
const esSentaraTyped: Translation = esSentara;
const esAvMedTyped: Translation = esAvMed;

// Get the correct resource based on BRAND
export function getEnResource() {
  return isAvMed() ? merge(enSentaraTyped, enAvMedTyped) : enSentaraTyped;
}

export function getEsResource() {
  return isAvMed() ? merge(esSentaraTyped, esAvMedTyped) : esSentaraTyped;
}

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: 'en-US',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'userLanguagePreference',
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      'en-US': {
        translation: getEnResource(),
      },
      es: {
        translation: getEsResource(),
      },
    },
  });

export default i18n;
